import * as React from 'react';
import './App.css';
import MainMenu from "./components/appmenu/MainMenu";
import {createTheme, ThemeProvider} from "@mui/material";
import {amber, blue, grey, orange, red} from "@mui/material/colors";
import {BrowserRouter} from "react-router";
import AppRoutes from "./AppRoutes";

export const theme = createTheme({
  palette: {
    primary: {
      main: amber[200]
    },
    secondary: {
      // main: 'rgba(246,230,168,0.73)'
      main: orange[200]
    },
    attention: {
      main: red[200]
    },
    water: {
      main: blue[300]
    },
    dark: {
      main: grey[800]
    }
  }
})

// this supports un-themed print page rendering...
//   keep this in sync with the actual theme palette!
export const APP_BAR_COLOR = '#fefbea'
export const SECONDARY = 'rgba(255,219,119,0.73)'
export const CONTENT_BACKGROUND = 'rgba(218,179,90,0.73)'
export const THEME_PRIMARY_COLOR = '#ffdb77'
export const DARK_ORANGE = '#ffc107'
export const THEME_FONT_COLOR = '#594d26'

function App(props) {
  // bypass router encapsulated components to single out only the component of interest for printing
  return (
      <ThemeProvider theme={theme}>
        <div className="App">
          <header className="App-content">
            <BrowserRouter future={{v7_relativeSplatPath: true, v7_startTransition: true}}>
              <MainMenu/>
              <AppRoutes/>
            </BrowserRouter>
          </header>
        </div>
      </ThemeProvider>
  );
}

export default App;
